import { render, staticRenderFns } from "./TokenValidation.vue?vue&type=template&id=b1879c82&scoped=true&"
import script from "./TokenValidation.vue?vue&type=script&lang=js&"
export * from "./TokenValidation.vue?vue&type=script&lang=js&"
import style0 from "./TokenValidation.vue?vue&type=style&index=0&id=b1879c82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1879c82",
  null
  
)

export default component.exports